/**
 * Speak a mode's instruction at the start of a round — and only for the first few.
 *
 * Every reward minigame shows its instruction somewhere: the Ice Maze asks for a topic, the Wagon
 * holds up a sign, the Labyrinth stands a rule across the top. Reading it aloud matters more here
 * than anywhere else in the game, because these boards are opened by a child who has just earned
 * something and is in a hurry to play, and because the modes are rare — a treat run may be weeks
 * apart, so the instruction is new again every time.
 *
 * **Only the first `INTRO_ROUNDS` rounds.** By the fourth board of a run the child is not learning
 * the rule any more, they are playing against it, and a voice repeating it every few seconds stops
 * being help and becomes noise to play through. It is also the same shape as the Labyrinth's
 * standing banner (specs/labyrinth-mode.md §4.2), which fades at the same rung for the same reason.
 *
 * Modes without rounds pass 1: they have a single instruction and it is spoken once.
 *
 * Silence stays a normal outcome — `speakRulePrompt` handles a muted voice or a language with no
 * voice installed, and never reads one language's words in another's voice.
 */
import { speakRulePrompt } from '@/game/audio';

/** Rounds that still get the instruction read aloud. */
export const INTRO_ROUNDS = 3;

export function speaksIntroOn(round: number): boolean {
  return Number.isFinite(round) && round <= INTRO_ROUNDS;
}

export function speakRoundIntro(text: string, lang: string, round: number): void {
  if (!text || !speaksIntroOn(round)) return;
  speakRulePrompt(text, lang);
}
